import { FC } from "react"

import { useAuth } from "../../../../../../auth"

import { DLMSiteApplicationsUserActionsCell } from "../../../../../../setsco/doclabel/applications/application-view/sites-list/DLMSiteApplicationsUserActionsCell"
import { DLMSiteApplicationsApplicantActionsCell } from "../../../../../../company/doclabel/application-view/sites-list/DLMSiteApplicationsApplicantActionsCell"
import { DLMSiteApplication } from "../../../../_models"

type Props = {
  site: DLMSiteApplication 
}

const DLMSiteApplicationsActionsCell: FC<Props> = ({site}) => {
    
    const { currentUser } = useAuth();

    if (currentUser?.isSetsco)  {
        return <DLMSiteApplicationsUserActionsCell site={site} />
    }

    return <DLMSiteApplicationsApplicantActionsCell site={site} />
}

export {DLMSiteApplicationsActionsCell}
